/* SDL template */


if (!window._abcFilter) {
    window._abcFilter = 0;
}


if (!customElements.get('facet-filters-form-new')) {
    class FacetFiltersFormNew extends HTMLElement {
        facetId = null;
        sectionId = null;
        gridContainerId = null;
        filterData = [];
        searchParamsInitial = window.location.search.slice(1);
        searchParamsPrev = window.location.search.slice(1);
        collectionHandle = null;

        constructor() {
            super();
            this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

            this.facetId = window._abcFilter++;
            this.sectionId = this.getAttribute('data-section-id');
            this.gridContainerId = this.getAttribute('data-grid-id');
            this.collectionHandle = this.getAttribute('data-collection-handle');

            if (!this.gridContainerId) {
                console.warn("Facet has no grid container set. Section = " + this.sectionId)
            }

            console.log('FC init: section = ' + this.sectionId + '; grid = ' + this.gridContainerId);

            this.debouncedOnSubmit = debounce((event) => {
                this.onSubmitHandler(event);
            }, 500);

            const facetForm = this.querySelector('form');

            facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

            // const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
            const facetWrapper = this.querySelector('.ctl-FacetsWrapperDesktop');
            if (facetWrapper) {
                // console.log('SOME');
                facetWrapper.addEventListener('keyup', onKeyUpEscape);
            }

            this.setListeners();
        }

        setListeners() {
            let that = this;
            const onHistoryChange = (event) => {
                const searchParams = event.state ? event.state.searchParams : that.searchParamsInitial;

                if (searchParams !== that.searchParamsPrev) {
                    that.renderPage(searchParams, null, false);
                }
            };
            window.addEventListener('popstate', onHistoryChange);
        }

        /**
         * TODO probably not used
         * @param disable
         */
        toggleActiveFacets(disable = true) {
            document.querySelectorAll('.js-facet-remove')
                .forEach((element) => {
                    element.classList.toggle('disabled', disable);
                });
        }

        renderPage(searchParams, event, updateURLHash = true) {
            if (!this.gridContainerId) {
                return;
            }

            this.searchParamsPrev = searchParams;

            const collectionHandler = document.querySelector('#' + this.gridContainerId + ' .collection');

            if (collectionHandler) {
                collectionHandler.classList
                    .add('loading');
            } else {
                console.warn('Can not found collection: #' + this.gridContainerId + ' .collection');
            }

            const countContainer = document.querySelectorAll('.ctl-product-count-' + this.sectionId);

            if (countContainer) {
                countContainer.forEach(element => {
                    element.classList.add('loading')
                });
            }

            const sections = this.getSections();

            sections.forEach((section) => {
                let url;

                if (this.collectionHandle) {
                    url = '/collections/' + this.collectionHandle
                } else {
                    console.warn('Collection handle missing: ' + this.sectionId);
                    url = window.location.pathname;
                }

                url += `?section_id=${section.section}&${searchParams}`;

                const filterDataUrl = element => element.url === url;

                this.filterData.some(filterDataUrl) ?
                    this.renderSectionFromCache(filterDataUrl, event) :
                    this.renderSectionFromFetch(url, event);
            });

            if (updateURLHash) this.updateURLHash(searchParams);
        }

        renderSectionFromFetch(url, event) {
            fetch(url)
                .then(response => response.text())
                .then((responseText) => {
                    const html = responseText;
                    this.filterData = [...this.filterData, {html, url}];
                    this.renderFilters(html, event);
                    this.renderProductGridContainer(html);
                    this.renderProductCount(html);
                });
        }

        renderSectionFromCache(filterDataUrl, event) {
            const html = this.filterData.find(filterDataUrl).html;
            this.renderFilters(html, event);
            this.renderProductGridContainer(html);
            this.renderProductCount(html);
        }

        renderProductGridContainer(html) {
            if (!this.gridContainerId) {
                return;
            }

            document.getElementById(this.gridContainerId)
                .innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(this.gridContainerId).innerHTML;
        }

        renderProductCount(html) {
            const count = new DOMParser().parseFromString(html, 'text/html')
                .querySelector('.ctl-product-count-' + this.sectionId)
                .innerHTML;
            const containerList = document.querySelectorAll('.ctl-product-count-' + this.sectionId);

            if (containerList) {
                containerList.forEach(container => {
                    container.innerHTML = count;
                    container.classList.remove('loading');
                });
            }
        }

        renderFilters(html, event) {
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

            const facetDetailsElements =
                // parsedHTML.querySelectorAll('#FacetFiltersFormNew .js-filter, #FacetFiltersFormNewMobile .js-filter, #FacetFiltersPillsForm .js-filter');
                parsedHTML.querySelectorAll('.ctl-FacetFiltersForm .js-filter, .ctl-FacetFiltersFormMobile .js-filter, .ctl-FacetFiltersPillsForm .js-filter');
            const matchesIndex = (element) => {
                const jsFilter = event ? event.target.closest('.js-filter') : undefined;
                return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
            };
            const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
            const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

            facetsToRender.forEach((element) => {
                // let node = this.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
                let node = document.querySelector('[data-section-id="' + this.sectionId + '"] .js-filter[data-index="' + element.dataset.index + '"]');

                if (node) {
                    node.innerHTML = element.innerHTML;
                } else {
                    console.warn('Can not find node: "' + this.sectionId + ` .js-filter[data-index="${element.dataset.index}"]"`);
                    console.log(['nod', document.querySelectorAll('[data-section-id="' + this.sectionId + '"] .js-filter[data-index="' + element.dataset.index + '"]')]);
                }
            });

            this.renderActiveFacets(parsedHTML);
            this.renderAdditionalElements(parsedHTML);

            if (countsToRender) {
                this.renderCounts(countsToRender, event.target.closest('.js-filter'));
            }
        }

        renderActiveFacets(html) {
            const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

            activeFacetElementSelectors.forEach((selector) => {
                const activeFacetsElement = html.querySelector(selector);
                const localElement = this.querySelector(selector);

                if (activeFacetsElement && localElement) {
                    // TODO redo....
                    localElement.innerHTML = activeFacetsElement.innerHTML;
                }
            });

            this.toggleActiveFacets(false);
        }

        renderAdditionalElements(html) {
            const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

            mobileElementSelectors.forEach((selector) => {
                if (html.querySelector(selector)) {
                    let el = document.querySelectorAll('[data-section-id="' + this.sectionId + '"] ' + selector);

                    if (el) {
                        el.innerHTML = html.querySelector(selector).innerHTML;
                    } else {
                        console.warn('Can not find el: ' + '[data-section-id="' + this.sectionId + '"] ' + selector);
                    }
                }
            });

            let mobileEl = this.querySelector('ctl-FacetFiltersFormMobile');

            if (mobileEl) {
                console.log('mobs: ' + this.sectionId);
                mobileEl.closest('menu-drawer')
                    .bindEvents();
            }
        }

        renderCounts(source, target) {
            const targetElement = target.querySelector('.facets__selected');
            const sourceElement = source.querySelector('.facets__selected');

            const targetElementAccessibility = target.querySelector('.facets__summary');
            const sourceElementAccessibility = source.querySelector('.facets__summary');

            if (sourceElement && targetElement) {
                target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
            }

            if (targetElementAccessibility && sourceElementAccessibility) {
                target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
            }
        }

        updateURLHash(searchParams) {
            history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        }

        getSections() {
            return [
                {
                    section: this.sectionId,
                }
            ]
        }

        createSearchParams(form) {
            const formData = new FormData(form);
            return new URLSearchParams(formData).toString();
        }

        onSubmitForm(searchParams, event) {
            this.renderPage(searchParams, event);
        }

        onSubmitHandler(event) {
            event.preventDefault();

            if (event.srcElement.className === 'mobile-facets__checkbox') {
                const searchParams = this.createSearchParams(event.target.closest('form'));
                this.onSubmitForm(searchParams, event)
            } else {
                const forms = [];
                const isMobile = event.target.closest('form').classList.contains('ctl-FacetFiltersFormMobile');
                const sortFilterForms = this.querySelectorAll('form');

                sortFilterForms.forEach((form) => {
                    if (!isMobile) {
                        if (
                            form.classList.contains('ctl-FacetSortForm')
                            || form.classList.contains('ctl-FacetFiltersForm')
                            || form.classList.contains('ctl-FacetSortDrawerForm')
                        ) {
                            forms.push(this.createSearchParams(form));
                        }
                    } else if (form.classList.contains('ctl-FacetFiltersFormMobile')) {
                        forms.push(this.createSearchParams(form));
                    }
                });

                this.onSubmitForm(forms.join('&'), event)
            }
        }

        onActiveFilterClick(event) {
            event.preventDefault();
            this.toggleActiveFacets();
            const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
            this.renderPage(url);
        }
    }

    // FacetFiltersFormNew.filterData = [];
    // FacetFiltersFormNew.searchParamsInitial = window.location.search.slice(1);
    // FacetFiltersFormNew.searchParamsPrev = window.location.search.slice(1);
    customElements.define('facet-filters-form-new', FacetFiltersFormNew);

    // FacetFiltersFormNew.setListeners();

    class PriceRangeNew extends HTMLElement {
        constructor() {
            super();
            this.querySelectorAll('input')
                .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
            this.setMinAndMaxValues();
        }

        onRangeChange(event) {
            this.adjustToValidValues(event.currentTarget);
            this.setMinAndMaxValues();
        }

        setMinAndMaxValues() {
            const inputs = this.querySelectorAll('input');
            const minInput = inputs[0];
            const maxInput = inputs[1];
            if (maxInput.value) minInput.setAttribute('max', maxInput.value);
            if (minInput.value) maxInput.setAttribute('min', minInput.value);
            if (minInput.value === '') maxInput.setAttribute('min', 0);
            if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
        }

        adjustToValidValues(input) {
            const value = Number(input.value);
            const min = Number(input.getAttribute('min'));
            const max = Number(input.getAttribute('max'));

            if (value < min) input.value = min;
            if (value > max) input.value = max;
        }
    }

    customElements.define('price-range-new', PriceRangeNew);

    class FacetRemoveNew extends HTMLElement {
        constructor() {
            super();
            const facetLink = this.querySelector('a');
            facetLink.setAttribute('role', 'button');
            facetLink.addEventListener('click', this.closeFilter.bind(this));
            facetLink.addEventListener('keyup', (event) => {
                event.preventDefault();
                if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
            });
        }

        closeFilter(event) {
            event.preventDefault();
            const form = this.closest('facet-filters-form-new') || document.querySelector('facet-filters-form-new');
            form.onActiveFilterClick(event);
        }
    }

    customElements.define('facet-remove-new', FacetRemoveNew);
}